import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum} from 'qcc'
import {appEnum} from 'utils/appEnum'
import api from 'api';

export default class RoleFormPage extends React.PureComponent<AppFormPageProps> {
    state = {}
    
	render() {
        let {formData,mode,id} = this.props;
        let {pos_merchant_id} = formData;
		return (<AppFormLayout defaultButton mode={this.props.mode}>
            <AppFormLayout.Form>
                <AppForm entity='pos_merchant_device' 
                loadingData={false} mode={mode} 
                keyValue={id} formData={formData} 
                afterSave={()=>{this.props.afterSave && this.props.afterSave()}}>
                    <AppForm.Section labelWidth={100}>
                        <AppForm.Item field='pos_merchant_id' dataType='number' itemType={AppFormItemEnum.hidden} />
                        <AppForm.Item field='mac' itemType={AppFormItemEnum.select} label="设备SN码" 
                        req unRepeat scopeField ='pos_merchant_id'
                        renderOptions = {()=>{ return api.posmerchant.getDeviceOptions({id:pos_merchant_id})}} 
                         />
						<AppForm.Item field='remarks' itemType={AppFormItemEnum.input} label="说明"/>
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/pos/merchant/DeviceAdd.tsx